import React from 'react';
import { Flex } from '@withjoy/joykit';
import { HotelTileList } from '../../components/Hotel';
import { HotelMap } from '../../components/Hotel/HotelMap';
import { HotelLoadingSkeleton } from '../../components/Hotel/HotelLoadingSkeleton';
import { useGuestEventHotelRoomBlocksQuery } from '@graphql/generated';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { pxToRem, styled } from '@withjoy/joykit/theme';
import { applyScrollBarStyles } from '@shared/utils/styles';

const ScrollableArea = styled(Flex)`
  ${applyScrollBarStyles};
  ::-webkit-scrollbar {
    width: 0;
  }
`;

interface Props {
  pageId: string;
  eventId: string;
  pageTitle?: string;
  isBrannanLayout?: boolean;
  isHotelCoupleNoteOpen?: boolean;
  handleCoupleNoteOpen?: () => void;
}

export const Custom: React.FC<Props> = ({ pageId, eventId, pageTitle, isHotelCoupleNoteOpen, isBrannanLayout, handleCoupleNoteOpen }) => {
  const { data, loading } = useGuestEventHotelRoomBlocksQuery({ variables: { eventId }, batchMode: 'fast' });
  const destination = data?.event?.hotelRoomBlocks?.destination || {};
  const reservedRoomBlocks = data?.event?.hotelRoomBlocks?.reservedRoomBlocks;
  const eventPhoto = data?.event?.photo?.url ?? '';

  const onSelectHotel = useEventCallback((id: string) => {
    const scrollEl = document.getElementById(id);
    if (scrollEl) {
      scrollEl.scrollIntoView({ behavior: 'smooth' });
    }
  });

  if (loading)
    return (
      <Flex width={'100%'} flexDirection={'column'}>
        <HotelLoadingSkeleton />
      </Flex>
    );

  return (
    <Flex
      flexDirection={isBrannanLayout ? 'row-reverse' : 'column'}
      justifyContent={'center'}
      alignItems={isBrannanLayout ? 'flex-start' : 'center'}
      width={'100%'}
      paddingY={7}
      paddingRight={7}
      height={isBrannanLayout ? pxToRem(864) : 'auto'}
      overflow={'hidden'}
    >
      {destination && reservedRoomBlocks && (
        <HotelMap destination={destination} reservedRoomBlocks={reservedRoomBlocks} pageTitle={pageTitle} onSelectHotel={onSelectHotel} isBrannanLayout={isBrannanLayout} />
      )}
      <ScrollableArea
        width={isBrannanLayout ? pxToRem(400) : '100%'}
        flex={isBrannanLayout ? 'none' : 'auto'}
        flexDirection={'column'}
        paddingLeft={isBrannanLayout ? 7 : 0}
        paddingRight={isBrannanLayout ? 7 : 0}
        height={isBrannanLayout ? pxToRem(800) : 'auto'}
        overflowY={'scroll'}
      >
        {reservedRoomBlocks && (
          <HotelTileList
            hotelTileListData={reservedRoomBlocks}
            destination={destination}
            eventPhoto={eventPhoto}
            handleCoupleNoteOpen={handleCoupleNoteOpen}
            isCoupleNoteOpen={isHotelCoupleNoteOpen}
          />
        )}
      </ScrollableArea>
    </Flex>
  );
};
